import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { COLLECTIONS, CHAPTERS } from "@/lib/data";
import { SHOP_ENABLED } from "@/lib/config";

export default function Collections() {
  return (
    <section
      id="collections"
      data-testid="collections-section"
      className="relative bg-[#050505] py-24 md:py-32"
    >
      <div className="w-full max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Manifesto chapters */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 mb-24 md:mb-32">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="border-t border-white/15 pt-6"
            >
              <span className="font-impact text-[#3FE1D1] text-5xl md:text-6xl leading-none">
                {c.no}
              </span>
              <h3 className="mt-4 font-display font-bold text-white text-2xl leading-tight">
                {c.title}
              </h3>
              <p className="mt-3 text-white/55 text-base leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>

        {/* Collections (shopping) — shown only when SHOP_ENABLED */}
        {SHOP_ENABLED && (
        <>
        <div className="flex items-end justify-between mb-12">
          <h2 className="font-display font-extrabold uppercase tracking-tighter text-white text-4xl md:text-6xl leading-[0.92]">
            Shop <span className="text-[#3FE1D1]">collections</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {COLLECTIONS.map((c, i) => (
            <motion.a
              key={c.name}
              href={c.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`collection-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group relative overflow-hidden aspect-[4/5] border border-[#262629]"
            >
              <img
                src={c.image}
                alt={c.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/30 to-transparent" />
              <div className="absolute inset-0 p-7 flex flex-col justify-end">
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-[#3FE1D1] text-xs uppercase tracking-[0.18em] font-semibold">
                      {c.count}
                    </p>
                    <h3 className="mt-1 font-display font-bold text-white text-2xl md:text-3xl leading-tight">
                      {c.name}
                    </h3>
                  </div>
                  <span className="h-11 w-11 flex-shrink-0 border border-white/30 flex items-center justify-center text-white group-hover:bg-[#3FE1D1] group-hover:border-[#3FE1D1] group-hover:text-[#050505] transition-colors duration-300">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
        </>
        )}
      </div>
    </section>
  );
}
